<div class="reporting-page-container">
    <div *ngIf="currentCustomPoll" class="page-header custom-page-header justify-content-between">
        <h2 class="page-header-title">{{currentCustomPoll.name}}</h2>
        <div *ngIf="currentCustomPoll.customPollTemplate.type === 'apv'" class="menu-buttons">
            <button class="menu-button"
                [ngClass]="isReporting ? 'menu-button-active':''"
                pButton type="button" 
                label="{{'custom_poll_main_reporting_btn1' | translate}}"
                (click)="changePages(true, false)"></button>
            <button class="menu-button"
                [ngClass]="isActionPlan ? 'menu-button-active':''"
                pButton type="button" 
                label="{{'custom_poll_main_reporting_btn2' | translate}}"
                (click)="changePages(false, true)"></button>
        </div>
        <span class="locked-date-text" *ngIf="currentCustomPoll.customPollTemplate.type === 'apv' && currentCustomPoll.isLocked && currentCustomPoll.reportDate">{{('custom_poll_main_reporting_lock_data_date' | translate: {date: (currentCustomPoll.reportDate.date | date:'dd MMM yyyy')})}}</span>
        <div *ngIf="currentCustomPoll.customPollTemplate.type === 'apv'" [ngClass]="{'locked-status': currentCustomPoll.isLocked, 'report-not-ready': currentCustomPoll.isLocked && !currentCustomPoll.reportIsReady}" class="generate-report-container" (click)="!currentCustomPoll.isLocked ? lockCustomPoll() : (currentCustomPoll.isLocked && currentCustomPoll.reportIsReady) ? downloadCustomPollReport(currentCustomPoll.reportPath):''">
            <i *ngIf="currentCustomPoll.isLocked" class="bi bi-file-earmark-pdf-fill pdf-icon"></i>
            <span pTooltip="{{'custom_poll_main_reporting_lock_data_tooltip' | translate}}" tooltipStyleClass="member-activity-tooltip" tooltipPosition="bottom" [tooltipDisabled]="currentCustomPoll.isLocked">{{(!currentCustomPoll.isLocked ? 'custom_poll_main_reporting_lock_data':'custom_poll_main_reporting_download_report')| translate}}</span>
        </div>
        <div *ngIf="currentCustomPoll.customPollTemplate.type !== 'apv'" class="generate-report-container">
            <i [ngStyle]="!actionPlanCompleted ? {'opacity':'20%'}:{}" class="bi bi-file-earmark-pdf-fill pdf-icon"></i>
            <span [ngStyle]="!actionPlanCompleted ? {'opacity':'20%', 'cursor':'default'}:{}" pTooltip="{{'wo_tooltip_coming_soon' | translate}}" tooltipStyleClass="tooltip-style" tooltipPosition="bottom" [tooltipDisabled]="!actionPlanCompleted">{{'wo_generate_report'| translate}}</span>
        </div>
    </div>
    <div class="loop-details-container" *ngIf="isReporting">
        <app-reporting-loop-details *ngIf="gotCategories || gotOnboardingReporting" [reportingDetails]="reportingDetails"></app-reporting-loop-details>
    </div>
    <div class="loop-categories-and-statements-container" *ngIf="isReporting">
        <app-categories-and-statements *ngIf="gotCategories"
            [reportingCategories]="reportingCategories"
            [categStatements]="reportingCategoriesStatements"
            [stateResponses]="reportingStatementsResponses"
            [reportingUserTeams]="userTeams"
            [categoryActions]="categoryActions"
            [actionAssignees]="actionAssignees"
            [currentCustomPoll]="currentCustomPoll"
            (categoryStatementEvent)="getCategoryStatements($event)"
            (statementResponsesEvent)="getStatementResponses($event)"
            (changedTeamEvent)="teamChanged($event)"
            (createActionEvent)="createCategoryAction($event)">
        </app-categories-and-statements>
        <app-onboarding-categories *ngIf="gotOnboardingReporting"
            [reportingCategories]="reportingCategories"
            [reportingDetails]="reportingDetails"
            [checkinStatements]="reportingCategoriesStatements"
            [stateResponses]="reportingStatementsResponses"
            [reportingTeamsForFilter]="userTeamsForOnboarding"
            [usersForFilter]="usersForFilter"
            (checkinStatementEvent)="getCheckinStatements($event)"
            (statementResponsesEvent)="getStatementResponses($event)"
            (changedTeamEvent)="teamChanged($event)"
            (selectedUser)="userChanged($event)"
            (selectedDateRange)="dateRangeChanged($event)"
            (resetFilters)="resetOnboardingFilters()">
        </app-onboarding-categories>
    </div>
    <div *ngIf="isActionPlan" class="loop-action-plan-container">
        <app-action-plan 
            [actions]="actionPlanActions"
            [actionsCategories]="reportingCategories"
            (filterCategories)="filterActionPlanActionsByCategory($event)">
        </app-action-plan>
    </div>
</div>

<button type="button" id="lockConfirmation" class="btn btn-primary" data-bs-toggle="modal" hidden
        data-bs-target="#lockConfirmationModal">
</button>

<div class="modal fade" id="lockConfirmationModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
     aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content edit-deadline-modal-content">
      <div class="modal-body edit-deadline-modal-body">
        <img src="../../../../assets/svg/close-button.svg" id="closeLockConfirmationModal" alt="X" data-bs-dismiss="modal"
             aria-label="Close"
             style="margin: 0 0 0 auto; cursor: pointer" (click)="$event.stopPropagation()">
        <span class="confirm-completed-modal-body">{{'custom_poll_main_reporting_lock_data_dialog_text1' | translate}}</span>
        <span class="confirm-completed-modal-body">{{'custom_poll_main_reporting_lock_data_dialog_text2' | translate}}</span>
        <div class="complete-confirmation-btns-con">
            <button 
                class="confirm-deadline-btn" pButton 
                label="{{'close_button' | translate}}"
                (click)="closeLockConfirmationModal();$event.stopPropagation()"></button>
        </div>
      </div>
    </div>
  </div>
</div>